<template>
  <div class="bgi-banner">
    <img src="@/assets/img/calc.jpg" alt="">
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
  },
  data() {
    return {
    };
  },
  components: {
  },
};
</script>

<style scoped>

</style>
